// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1jAbI","subheader":"ReorderModal_subheader__117_g","listWrap":"ReorderModal_listWrap__3PXWW"};